import { render } from "./CompletarDatosBasicos.vue?vue&type=template&id=fbb56aa2"
import script from "./CompletarDatosBasicos.vue?vue&type=script&lang=js"
export * from "./CompletarDatosBasicos.vue?vue&type=script&lang=js"

import "./CompletarDatosBasicos.vue?vue&type=style&index=0&id=fbb56aa2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__